import { DefaultDeadline, SelectData } from "../../models";
import { OrganisationTypeConstants } from "../organisation";
import { ProjectPhase } from "../project-phase";

export class TemplateTaskConstants {
  public static readonly DEADLINE_OPERATOR_MAP: Record<string, string> = {
    "Feasibility start date": "+",
    "Design start date": "+",
    "Implementation start date": "+",
    "Ongoing monitoring start date": "+",
    "Feasibility end date": "-",
    "Design end date": "-",
    "Implementation end date": "-",
    "Ongoing monitoring end date": "-",
    "Start date|Design": "-",
    "Implementation date|Design": "-",
    "Registration date|Feasibility": "-",
  };

  public static readonly PHASE_KEY_DATES_SELECT_DATA_MAP = {
    [ProjectPhase.feasibility]: [
      { key: "Creation date", value: "Creation date" },
      { key: "Registration date", value: "Registration date" },
      { key: "Feasibility start date", value: "Feasibility start date" },
      { key: "Feasibility end date", value: "Feasibility end date" },
    ] as SelectData,
    [ProjectPhase.design]: [
      { key: "Registration date", value: "Registration date" },
      { key: "Start date", value: "Project start date" },
      { key: "Implementation date", value: "Project implementation date" },
      { key: "Design start date", value: "Design start date" },
      { key: "Design end date", value: "Design end date" },
    ] as SelectData,
    [ProjectPhase.implementation]: [
      { key: "Start date", value: "Project start date" },
      { key: "Implementation date", value: "Project implementation date" },
      { key: "Validation date", value: "Validation date" },
      { key: "Implementation start date", value: "Implementation start date" },
      { key: "Implementation end date", value: "Implementation end date" },
    ] as SelectData,
    [ProjectPhase.ongoingMonitoring]: [
      { key: "Validation date", value: "Validation date" },
      { key: "Ongoing monitoring start date", value: "Ongoing monitoring start date" },
      { key: "Ongoing monitoring end date", value: "Ongoing monitoring end date" },
    ] as SelectData,
  };

  public static readonly DEADLINE_OPERATOR_SELECT_DATA = [
    { key: "+", value: "+" },
    { key: "-", value: "-" },
  ] as SelectData;

  public static readonly DEADLINE_CALENDAR_UNIT_SELECT_DATA = [
    { key: "days", value: "days" },
    { key: "weeks", value: "weeks" },
    { key: "months", value: "months" },
    { key: "years", value: "years" },
  ] as SelectData;

  public static readonly ORGANISATION_TYPE_SELECT_DATA_KEYS = {
    [OrganisationTypeConstants.DEVELOPER]: "Developer",
    [OrganisationTypeConstants.DEVELOPMENT_MANAGER]: "Development Manager",
    [OrganisationTypeConstants.ASSET_MANAGER]: "Asset Manager",
    [OrganisationTypeConstants.GUEST]: "Guest",
  };

  public static readonly ORGANISATION_TYPE_SELECT_DATA = [
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.DEVELOPER],
      value: "Developer",
    },
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.DEVELOPMENT_MANAGER],
      value: "Development Manager",
    },
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.ASSET_MANAGER],
      value: "Asset Manager",
    },
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.GUEST],
      value: "Guest",
    },
  ] as SelectData;

  public static readonly DEADLINE_CALENDAR_UNIT_MULTIPLIERS = {
    days: 1,
    weeks: 7,
    months: 30,
    years: 365,
  };

  public static readonly DEFAULT_TEMPLATE_TASK = {
    defaultDeadlineField: null,
    defaultDeadlineValue: null,
    defaultIsMandatory: null,
    defaultIsMilestone: null,
    defaultKeyDate: null,
    defaultRepeat: null,
    defaultTaskDescription: null,
    defaultTaskName: null,
    defaultVisibility: null,
    ownerOrganisationType: null,
    workflowTemplateStepUuid: null,
  };

  public static readonly DEFAULT_DEADLINE = {
    operator: "+",
    value: 0,
    unit: "days",
  } as DefaultDeadline;
}
